import React from 'react'
import styled from 'styled-components';
import { darken } from 'polished'


export default styled.a`
  &&& {
    font-size: 14px;
    color: ${props => props.theme.primary};
    text-align: right;
    line-height: ${props => props.inline ? '17px' : '24px'};
    
    &:hover {
      color: ${props => darken(0.1, props.theme.primary)};  
    }
  }
`;